import { render } from "./ImageLink.vue?vue&type=template&id=477899ee"
import script from "./ImageLink.vue?vue&type=script&lang=js"
export * from "./ImageLink.vue?vue&type=script&lang=js"

import "./ImageLink.vue?vue&type=style&index=0&id=477899ee&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__